const successBoldLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M23.25 12c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12 5.787.75 12 .75 23.25 5.787 23.25 12m-15.754.16 1.098-1.039 2.515 2.625 4.899-5.098 1.082 1.04-5.98 6.226z" clip-rule="evenodd"/></svg>',
};

export { successBoldLarge as default };
